const ErrorApi = `
    <div id='error-api' class='h-100'> 
        <div class='wrapper flex-column justify-content-center h-100'>
            <p>Se ha producido un error en el servidor</p>
            <p class='mt-1'>Intentalo de nuevo mas tarde, o visite mi 
                <a href='https://www.linkedin.com/in/juanlopezaragon/'>Linkedin</a> Gracias
            </p>
        </div>
    </div>`

export default ErrorApi
